import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import { ofType } from 'redux-observable';
import { Observable, OperatorFunction, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { Action, ActionType } from 'typesafe-actions';
import { NafEvents } from '@appTypes/nafEvents';
import { Actions, Validation, actions } from '@redux/modules/nafEvents';
import { TypedEpic } from './types';

const fetchNafEventsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_NAF_EVENTS),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getNafEvents.request>[]
    >,
    switchMap(([action]) => {
      const params: Record<string, any> = {
        take: action.payload.take,
      };

      if (action.payload.postalNumber) {
        params.postalNumber = action.payload.postalNumber;
      }

      return fromApiRequest((signal) =>
        apiClient.get<{ items: NafEvents[]; total: number; validation: Validation }>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].nafEvents.list(action?.payload.organizer),
          params,
        }),
      ).pipe(
        map((response) => {
          if (Array.isArray(response?.data?.items)) {
            return actions.getNafEvents.success({ items: response.data.items, total: response?.data?.total });
          }
          return actions.getNafEvents.failure(toReduxError(undefined, GENERIC_FETCH_ERROR_MESSAGE));
        }),
        catchError((e) => {
          if (e.response?.validation) {
            return of(actions.getNafEvents.failure(e.response.validation));
          }
          return of(actions.getNafEvents.failure(toReduxError(e, GENERIC_FETCH_ERROR_MESSAGE)));
        }),
      );
    }),
  );

export const epics: TypedEpic[] = [fetchNafEventsEpic];
